import { Translations } from './fr';

export const pt: Translations = {
  nav: {
    home: "Início",
    primeEvolution: "Evolution",
    pulse: "Pulse",
    sparkle: "Sparkle",
    agents: "Agentes",
    partners: "Parceiros",
    contact: "Contato",
    recruitAgent: "Recrutar Agente",
  },
  hero: {
    title: "Recrute nossos",
    titleHighlight: "Agentes IA",
    titleEnd: "para Fortalecer suas Equipes",
    subtitle: "Colaboradores virtuais disponíveis 24/7, treinados nos seus processos de negócio, prontos para transformar sua produtividade.",
    cta: "Recrutar um Agente IA",
    discover: "Descobrir Prime Evolution",
  },
  trust: {
    available: "Disponível 24/7",
    secure: "100% Seguro",
    agents: "Agentes Certificados",
    support: "Suporte Dedicado",
  },
  primeEvolution: {
    badge: "Nossa Solução Principal",
    title: "Prime Evolution",
    subtitle: "O programa de acompanhamento completo para integrar IA na sua empresa",
    description: "Prime Evolution é nossa abordagem holística que combina auditoria, treinamento e implantação de agentes IA personalizados.",
    features: {
      audit: { title: "Auditoria Estratégica", description: "Análise aprofundada dos seus processos para identificar oportunidades de automação." },
      training: { title: "Treinamento de Equipes", description: "Programas de treinamento adaptados para colaboração eficaz com IA." },
      deployment: { title: "Implantação Personalizada", description: "Agentes IA personalizados integrados às suas ferramentas existentes." },
      support: { title: "Suporte Contínuo", description: "Suporte dedicado e otimização contínua." },
    },
    cta: "Iniciar Prime Evolution",
    stats: { productivity: "Ganho médio de produtividade", roi: "Retorno sobre investimento", satisfaction: "Taxa de satisfação" },
  },
  pulse: {
    badge: "Automação Inteligente",
    title: "VEECTORIA Pulse",
    subtitle: "Automação que pulsa no ritmo da sua empresa",
    description: "Pulse é nossa plataforma de automação inteligente que conecta e orquestra seus workflows em tempo real.",
    features: {
      connect: { title: "Conecte", description: "Integração nativa com mais de 200 ferramentas profissionais." },
      orchestrate: { title: "Orquestre", description: "Workflows inteligentes que se adaptam automaticamente." },
      optimize: { title: "Otimize", description: "Análise em tempo real e recomendações para melhorar processos." },
    },
    cta: "Descobrir Pulse",
  },
  advantages: {
    badge: "Por Que Nos Escolher",
    title: "Vantagens VEECTORIA",
    subtitle: "Uma abordagem única que combina expertise humana e poder da IA",
    items: {
      expertise: { title: "Expertise Reconhecida", description: "Mais de 10 anos de experiência em transformação digital e IA." },
      custom: { title: "Soluções Personalizadas", description: "Cada agente é especificamente treinado nos seus processos." },
      security: { title: "Segurança Máxima", description: "Dados hospedados na Europa, conformidade LGPD garantida." },
      roi: { title: "ROI Garantido", description: "Compromisso com resultados mensuráveis." },
      support: { title: "Suporte 24/7", description: "Equipe dedicada disponível a qualquer momento." },
      evolution: { title: "Evolução Contínua", description: "Seus agentes melhoram constantemente através de machine learning." },
    },
  },
  sparkle: {
    badge: "Digitalização Inteligente",
    title: "Sparkle",
    subtitle: "TagPDF v7 com IA",
    description: "Transforme seus documentos em papel em dados utilizáveis com nossa solução de digitalização inteligente. Reconhecimento automático, extração de dados e classificação inteligente.",
    features: {
      scan: {
        title: "Digitalização Avançada",
        description: "OCR de alta precisão para todos os tipos de documentos.",
      },
      ai: {
        title: "IA Integrada",
        description: "Classificação e extração automática de dados-chave.",
      },
      speed: {
        title: "Processamento Ultra-Rápido",
        description: "Milhares de páginas processadas em minutos.",
      },
      accuracy: {
        title: "Máxima Precisão",
        description: "Taxa de reconhecimento superior a 99%.",
      },
    },
    cta: "Descobrir Sparkle",
    ctaFulltext: "Indexação Full-text",
    ctaFulltextDesc: "Pesquise instantaneamente em todos os seus documentos.",
    ctaScan: "Scan Relâmpago → Pasta",
    ctaScanDesc: "Digitalize e organize num piscar de olhos.",
  },
  testimonials: {
    badge: "Depoimentos",
    title: "Eles Confiam em Nós",
    subtitle: "Descubra como nossos clientes transformam seus negócios com VEECTORIA",
    items: [
      { quote: "Graças à VEECTORIA, reduzimos tarefas administrativas em 70%.", metric: "-70%", metricLabel: "tempo admin", name: "Isabelle G.", role: "Gerente Administrativa" },
      { quote: "O agente IA comercial transformou nossa prospecção. +40% agendamentos qualificados.", metric: "+40%", metricLabel: "agendamentos qualificados", name: "Marc D.", role: "Diretor Comercial" },
      { quote: "A solução documental nos economiza tempo precioso na gestão de dossiês.", metric: "5x", metricLabel: "mais rápido", name: "Sophie M.", role: "Gerente" },
    ],
  },
  faq: {
    badge: "Perguntas Frequentes",
    title: "Tudo sobre VEECTORIA",
    subtitle: "Respostas às suas perguntas mais comuns",
    items: {
      q1: { question: "O que é um Agente IA VEECTORIA?", answer: "Um colaborador virtual inteligente treinado nos seus processos de negócio específicos." },
      q2: { question: "Quanto tempo leva a implantação?", answer: "A implantação padrão leva 2-4 semanas, para necessidades mais complexas 6-8 semanas." },
      q3: { question: "Meus dados estão seguros?", answer: "Absolutamente. Todos os dados são hospedados na Europa em servidores certificados, 100% conformes com LGPD." },
      q4: { question: "Qual é o retorno esperado?", answer: "Nossos clientes veem um ganho de produtividade de 40% e ROI positivo em 3 meses." },
      q5: { question: "Como funciona a integração?", answer: "VEECTORIA se integra nativamente com mais de 200 ferramentas profissionais." },
    },
  },
  contact: {
    badge: "Entre em Contato",
    title: "Pronto para Transformar sua Empresa?",
    subtitle: "Vamos discutir suas necessidades e descobrir como VEECTORIA pode apoiá-lo",
    form: {
      name: "Nome completo",
      email: "E-mail profissional",
      company: "Empresa",
      phone: "Telefone",
      message: "Sua mensagem",
      submit: "Enviar mensagem",
      sending: "Enviando...",
      success: "Mensagem enviada com sucesso!",
      error: "Erro ao enviar. Por favor, tente novamente.",
    },
    info: { title: "Informações de Contato", email: "E-mail", phone: "Telefone", address: "Endereço" },
  },
  cta: {
    title: "Pronto para Agir?",
    subtitle: "Junte-se às empresas que já transformaram sua produtividade com VEECTORIA",
    button: "Recrutar um Agente IA",
  },
  footer: {
    description: "Soluções de inteligência artificial para transformar sua empresa.",
    navigation: "Navegação",
    legal: "Aviso Legal",
    privacy: "Política de Privacidade",
    terms: "Termos e Condições",
    cookies: "Configurações de Cookies",
    rights: "Todos os direitos reservados.",
  },
  agents: {
    badge: "Nossa Equipe",
    title: "Nossos Agentes IA",
    subtitle: "Descubra nossos colaboradores virtuais prontos para se juntar à sua equipe",
  },

  // AI Agents Showcase
  agentsShowcase: {
    badge: "A Excelência da IA ao Serviço da Sua Empresa",
    title: "Os Nossos Agentes IA Transformam o Seu Dia a Dia",
    description: "Imagine uma equipa de colaboradores virtuais que nunca dorme, aprende continuamente e se adapta perfeitamente aos seus processos de negócio. Os nossos Agentes IA amplificam as suas capacidades, libertam os seus talentos de tarefas repetitivas e impulsionam a sua produtividade para novos patamares.",
    imageAlt: "Equipa de Agentes IA VEECTORIA",
    cta: "Descobrir os Nossos Agentes",
    benefits: {
      availability: "Disponíveis 24/7",
      productivity: "Produtividade x10",
      performance: "Desempenho Ótimo",
      collaboration: "Colaboração Fluida",
    },
  },
  cookies: {
    title: "Gestão de cookies",
    message: "Usamos cookies para melhorar a sua experiência no nosso site, analisar o tráfego e personalizar o conteúdo.",
    accept: "Aceitar tudo",
    decline: "Recusar",
    settings: "Personalizar",
    settingsTitle: "Configurações de cookies",
    settingsDescription: "Gerencie as suas preferências de cookies. Os cookies essenciais são necessários para o funcionamento do site e não podem ser desativados.",
    saveChoices: "Guardar as minhas escolhas",
    rejectAll: "Recusar tudo",
    alwaysActive: "Sempre ativo",
    categories: {
      essential: { name: "Cookies essenciais", description: "Estes cookies são necessários para o funcionamento do site e não podem ser desativados." },
      analytics: { name: "Cookies analíticos", description: "Estes cookies permitem-nos medir a audiência do site e analisar o comportamento de navegação." },
      marketing: { name: "Cookies de marketing", description: "Estes cookies são utilizados para oferecer anúncios personalizados." },
      preferences: { name: "Cookies de preferências", description: "Estes cookies memorizam as suas preferências (idioma, tema, região)." },
    },
  },

  // Partners Section
  partners: {
    badge: "Programa de Parceiros",
    title: "Desenvolvamos Juntos",
    description: "É revendedor, distribuidor, editor de software ou grossista? A VEECTORIA torna-se o seu parceiro tecnológico privilegiado para conquistar novos mercados com soluções de inteligência artificial de ponta.",
    valueProposition: "Concebemos e desenvolvemos soluções profissionais completas e personalizadas para os seus clientes, enquanto o apoiamos na implementação de uma estratégia de comercialização em massa. Margens atrativas, suporte técnico dedicado e assistência de marketing: todos os ingredientes para o seu sucesso.",
    types: {
      resellers: { title: "Revendedores", description: "Integre as nossas soluções de IA no seu catálogo e ofereça pacotes diferenciadores." },
      distributors: { title: "Distribuidores", description: "Implemente as nossas tecnologias em grande escala no seu território." },
      editors: { title: "Editores de Software", description: "Enriqueça o seu software com a nossa IA para um valor acrescentado incomparável." },
      wholesalers: { title: "Grossistas", description: "Aceda a tarifas preferenciais para distribuição em massa nas suas redes." },
    },
    benefits: {
      title: "Os Seus Benefícios de Parceiro",
      whiteLabel: "Soluções marca branca",
      support: "Suporte técnico dedicado",
      scalability: "Escalabilidade ilimitada",
    },
    cta: "Torne-se Parceiro",
    ctaSubtext: "Contacte-nos para descobrir o nosso programa de parceiros exclusivo",
  },

  legal: {
    lastUpdate: "Última atualização: Janeiro 2026",
    mentions: {
      title: "Aviso Legal",
      sections: {
        editor: { title: "1. Editor do site", intro: "Este site é editado por:", companyName: "Razão social", legalForm: "Forma jurídica", capital: "Capital social", address: "Sede", siren: "SIREN", siret: "SIRET", rcs: "RCS", tva: "NIF", naf: "Código NAF" },
        publication: { title: "2. Diretor de publicação", intro: "A publicação é gerida por:", since: "desde" },
        contact: { title: "3. Contato", phone: "Telefone", email: "E-mail" },
        hosting: { title: "4. Hospedagem", intro: "O site é hospedado por:", name: "Nome", address: "Endereço" },
        intellectual: { title: "5. Propriedade intelectual", content1: "Todo este site está sujeito à legislação francesa e internacional sobre direitos autorais e propriedade intelectual.", content2: "A reprodução deste site, total ou parcial, é estritamente proibida sem autorização expressa de" },
        liability: { title: "6. Limitação de responsabilidade", content: "As informações neste site são tão precisas quanto possível. {company} não pode ser responsabilizada por danos diretos ou indiretos resultantes do uso deste site." },
        law: { title: "7. Lei aplicável", content: "Este site está sujeito à lei francesa. Em caso de litígio, os tribunais franceses terão jurisdição exclusiva." },
      },
    },
    privacy: {
      title: "Política de Privacidade",
      sections: {
        intro: { title: "1. Introdução", content: "{company} compromete-se a proteger a privacidade dos utilizadores do seu site. Esta política explica como recolhemos, utilizamos e protegemos os seus dados pessoais de acordo com o RGPD." },
        controller: { title: "2. Responsável pelo tratamento", company: "Empresa", address: "Endereço", email: "E-mail" },
        data: { title: "3. Dados recolhidos", intro: "Recolhemos os seguintes dados:", items: ["Dados de identificação: nome, apelido, e-mail, telefone", "Dados profissionais: empresa, cargo", "Dados de navegação: endereço IP, cookies, páginas visitadas", "Dados de comunicação: mensagens via formulários"] },
        purposes: { title: "4. Finalidades do tratamento", intro: "Os seus dados são recolhidos para:", items: ["Responder aos seus pedidos de contacto", "Fornecer os nossos serviços de IA", "Melhorar o nosso site", "Enviar comunicações comerciais (com o seu consentimento)", "Cumprir obrigações legais"] },
        basis: { title: "5. Base legal", intro: "O tratamento baseia-se em:", items: ["O seu consentimento explícito", "Execução de contrato", "O nosso interesse legítimo", "Obrigações legais"] },
        retention: { title: "6. Período de conservação", content: "Os seus dados são conservados pelo tempo necessário, no máximo 3 anos após o último contacto." },
        rights: { title: "7. Os seus direitos", intro: "De acordo com o RGPD, tem os seguintes direitos:", access: "Direito de acesso", accessDesc: "obter uma cópia dos seus dados", rectification: "Direito de retificação", rectificationDesc: "corrigir dados inexatos", erasure: "Direito de apagamento", erasureDesc: "solicitar a eliminação dos seus dados", restriction: "Direito de limitação", restrictionDesc: "limitar o tratamento", portability: "Direito de portabilidade", portabilityDesc: "receber dados em formato estruturado", objection: "Direito de oposição", objectionDesc: "opor-se ao tratamento", contact: "Para exercer estes direitos, contacte-nos:" },
        security: { title: "8. Segurança", content: "Implementamos medidas técnicas e organizacionais adequadas para proteger os seus dados." },
        complaint: { title: "9. Reclamação", content: "Pode apresentar uma reclamação à CNIL: www.cnil.fr" },
      },
    },
    cgv: {
      title: "Termos e Condições",
      sections: {
        object: { title: "1. Objeto", content: "Estes Termos regem as relações contratuais entre {company} e os seus clientes para serviços de IA, desenvolvimento de software e soluções empresariais." },
        provider: { title: "2. Prestador", company: "Empresa", siret: "SIRET", address: "Endereço" },
        services: { title: "3. Serviços oferecidos", intro: "{company} oferece os seguintes serviços:", items: ["Agentes IA especializados", "Aplicações empresariais personalizadas (Prime Evolution)", "Soluções de IA documental", "VEECTORIA Pulse - Plataforma de transcrição", "Consultoria e integração de IA"] },
        quotes: { title: "4. Orçamentos e encomendas", content: "Todos os serviços são baseados num orçamento detalhado." },
        pricing: { title: "5. Preços e pagamento", content1: "Preços em euros sem IVA. IVA de 20%. Pagável em 30 dias.", content2: "Em caso de atraso, aplicam-se juros de mora." },
        delivery: { title: "6. Entrega e prazos", content: "Os prazos são indicativos. {company} esforça-se por cumprir os prazos acordados." },
        intellectual: { title: "7. Propriedade intelectual", content: "Os desenvolvimentos permanecem propriedade de {company} até pagamento integral." },
        confidentiality: { title: "8. Confidencialidade", content: "Ambas as partes comprometem-se à confidencialidade por 3 anos após o fim do contrato." },
        liability: { title: "9. Limitação de responsabilidade", content: "A responsabilidade de {company} é limitada ao valor do contrato." },
        law: { title: "10. Lei aplicável", content: "Aplica-se a lei francesa. O tribunal competente é Paris." },
      },
    },
    cookiesPolicy: {
      title: "Política de Cookies",
      sections: {
        what: { title: "1. O que é um cookie?", content: "Um cookie é um pequeno ficheiro de texto colocado no seu dispositivo ao visitar um site." },
        types: { title: "2. Cookies utilizados", intro: "O nosso site utiliza os seguintes cookies:", essential: "Cookies essenciais", essentialDesc: "Necessários para o funcionamento do site.", analytics: "Cookies analíticos", analyticsDesc: "Ajudam-nos a compreender o uso.", preferences: "Cookies de preferências", preferencesDesc: "Memorizam as suas escolhas." },
        retention: { title: "3. Período de conservação", content: "Os cookies são conservados por um máximo de 13 meses." },
        management: { title: "4. Gestão de cookies", intro: "Pode alterar as suas preferências a qualquer momento:", items: ["Chrome: Definições → Privacidade → Cookies", "Firefox: Opções → Privacidade → Cookies", "Safari: Preferências → Privacidade → Cookies", "Edge: Definições → Cookies"] },
        contact: { title: "5. Contacto", content: "Para questões sobre cookies, contacte-nos:" },
      },
    },
  },
};
